import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './Admin.css';
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import AdminUsers from './AdminUsers';
import AdminRoles from './AdminRoles';
import AdminPermissions from './AdminPermissions';
import AdminClients from './AdminClients';

class AdminContainer extends Component {
    constructor(props) {
        super(props);
        this.blankUser = {
            auth0: '',
            firstName: '',
            lastName: '',
            emailAddress: '',
            active: 1,
            roles: [],
            clients: [],
            employeeId: 0
        }
        this.blankRole = {
            id: 0,
            role: '',
            description: '',
            active: true,
            order: 0,
            permissions: [],
            users: []
        }
        this.blankPermission = {
            id: 0,
            permission: '',
            description: '',
            api: '',
            method: '',
            active: true,
            order: 0,
            roles: []
        }
        this.blankClient = {
            id: 0,
            client: '',
            uuid: '',
            customerNumber: '',
            active: true,
            users: []
        }
        this.state = {
            users: [],
            employees: [],
            newUser: { ...this.blankUser },
            editUser: { ...this.blankUser },
            editClient: { ...this.blankClient },
            newClient: { ...this.blankClient },
            roles: [],
            newRole: { ...this.blankRole },
            editRole: { ...this.blankRole },
            permissions: [],
            newPermission: { ...this.blankPermission },
            editPermission: { ...this.blankPermission },
            isLoaded: 0,
            errorMessage: ''
        };
    }

    componentDidMount() {
        this.props.log('AdminContainer.js/componentDidMount');
        this.getUsers();
        this.getRoles();
        this.getPermissions();
        this.getEmployees();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getEmployees = () => {
        this.props.log('Client.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data
                            .filter(employee => employee.active)
                            .map(employee => {
                                return ({
                                    employeeId: employee.employeeId,
                                    firstName: employee.firstName,
                                    lastName: employee.lastName
                                })
                            })
                            .sort((a, b) => a.lastName.localeCompare(b.lastName))
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getUsers = () => {
        this.props.log('AdminContainer.js/getUsers');
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState((prevState, props) => {
                        let return_value = {
                            'users': results.data,
                            'isLoaded': this.state.isLoaded + 1
                        };
                        return return_value;
                    });
                } else {
                    this.props.addToast('Unable to load users.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getRoles = () => {
        this.props.log('AdminContainer.js/getRoles');
        fetch('/api/roles/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState((prevState, props) => {
                        let return_value = {
                            'roles': results.data,
                            'isLoaded': this.state.isLoaded + 1
                        };
                        return return_value;
                    });
                } else {
                    this.props.addToast('Unable to load roles.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getPermissions = () => {
        this.props.log('AdminContainer.js/getPermissions');
        fetch('/api/permissions/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState((prevState, props) => {
                        let return_value = {
                            'permissions': results.data,
                            'isLoaded': this.state.isLoaded + 1
                        };
                        return return_value;
                    });
                } else {
                    this.props.addToast('Unable to load permissions.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSelectAll = (e, obj) => {
        this.props.log('AdminContainer.js/onSelectAll (obj)', obj);
        if (obj.targetPath == null) obj.targetPath = 'state';
        if (obj.typePath == null) obj.typePath = 'state';
        if (obj.filterTypePath == null) obj.filterTypePath = 'state';
        let selectAll = false;
        if (obj.filterType != null & obj.filterKey != null) {
            selectAll = [...this[obj.targetPath][obj.target]].filter(i => (i[obj.type].findIndex(j => j === this[obj.filterTypePath][obj.filterType][obj.filterKey]) > -1)).length === this[obj.targetPath][obj.target].length
            this.setState((prevState) => {
                let retObj = { ...prevState };
                retObj[obj.target].forEach(i => {
                    if (selectAll) {
                        const index = i[obj.type].findIndex(j => j === this[obj.filterTypePath][obj.filterType][obj.filterKey]);
                        i[obj.type].splice(index, 1);
                    } else {
                        if (i[obj.type].findIndex(j => j === this[obj.filterTypePath][obj.filterType][obj.filterKey]) === -1) {
                            console.log('b',this[obj.filterTypePath][obj.filterType][obj.filterKey])
                            i[obj.type].push(this[obj.filterTypePath][obj.filterType][obj.filterKey]);
                        }
                    }
                })
                return retObj;
            })
        } else {
            selectAll = this[obj.targetPath][obj.target][obj.type].length !== this[obj.typePath][obj.type].length;
            this.setState((prevState) => {
                let retObj = { ...prevState };
                retObj[obj.target][obj.type] = selectAll ? this[obj.typePath][obj.type].map(item => item[obj.typeKey]) : [];
                return retObj;
            })
        }
    }

    onEditUser = (auth0) => {
        this.props.log('AdminContainer.js/onEditUser (auth0)', auth0);
        const user = [...this.state.users].filter(item => item.auth0 === auth0)[0];
        this.setState(() => {
            return {
                editUser: {
                    'auth0': auth0,
                    'firstName': user['firstName'],
                    'lastName': user['lastName'],
                    'emailAddress': user['emailAddress'],
                    'employeeId': user.employeeId,
                    'active': user.active,
                    'roles': user.roles,
                    'clients': user.clients
                }
            }
        })
    }

    onChangeUser = (e, type) => {
        this.props.log('AdminContainer.js/onChangeUser (e, type)', e, type);
        e.persist();
        let thisUser = (type === 'edit') ? this.state.editUser : this.state.newUser;
        switch (e.target.name) {
            case "active":
                thisUser[e.target.name] = !thisUser[e.target.name];
                break;
            case "roles":
                const id = parseInt(String(e.target.id).split('_')[1]);
                const index = thisUser.roles.findIndex(item => item === id);
                if (index > -1) thisUser.roles.splice(index, 1);
                if (e.target.checked) thisUser.roles.push(id);
                break;
            case "clients":
                const clientId = parseInt(String(e.target.id).split('_')[1]);
                const clientIndex = thisUser.clients.findIndex(item => item === clientId);
                if (clientIndex > -1) thisUser.clients.splice(clientIndex, 1);
                if (e.target.checked) thisUser.clients.push(clientId);
                const clientIndex2 = [...this.props.clients].findIndex(item => item.id === clientId);
                const userIndex2 = [...this.props.clients][clientIndex2].users.findIndex(item => item === thisUser.auth0);
                if (userIndex2 > -1) [...this.props.clients][clientIndex2].users.splice(userIndex2, 1);
                if (e.target.checked) [...this.props.clients][clientIndex2].users.push(thisUser.auth0);
                break;
            default:
                thisUser[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editUser: thisUser } : { newUser: thisUser };
        });
    }

    handleCancelUser = () => {
        this.props.log('AdminContainer.js/handleCancelUser');
        this.setState({
            editUser: { ...this.blankUser },
        })
    }

    handleAddUser = (e) => {
        this.props.log('AdminContainer.js/handleAddUser (name, value, e)', e.target.name, e.target.value, e);
        let userId = '';
        fetch('/api/auth/', {
            method: 'POST',
            body: JSON.stringify({
                firstName: this.state.newUser.firstName,
                lastName: this.state.newUser.lastName,
                name: this.state.newUser.firstName + ' ' + this.state.newUser.lastName,
                email: this.state.newUser.emailAddress,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    userId = results.data.user_id;
                    fetch('/api/users/', {
                        method: 'POST',
                        body: JSON.stringify({
                            firstName: this.state.newUser.firstName,
                            lastName: this.state.newUser.lastName,
                            emailAddress: this.state.newUser.emailAddress,
                            auth0: userId.split('|')[1],
                            active: this.state.newUser.active,
                            employeeId: this.state.newUser.employeeId
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.props.clientToken
                        }
                    })
                        .then(results2 => results2.json())
                        .then(results2 => {
                            if (results2.success) {
                                let users = [...this.state.users];
                                users.push({
                                    'active': this.state.newUser.active,
                                    'auth0': userId.split('|')[1],
                                    'clients': [],
                                    'emailAddress': this.state.newUser.emailAddress,
                                    'firstName': this.state.newUser.firstName,
                                    'lastName': this.state.newUser.lastName,
                                    'employeeId': this.state.newUser.employeeId,
                                    'roles': []
                                });
                                this.setState({
                                    users: users,
                                    newUser: { ...this.blankUser }
                                }, () => {
                                    this.props.addToast('User addedd successfully.', 5, 'success')
                                });
                            } else {
                                this.props.addToast('Unable to add user in application.', 5, 'danger');
                            }
                        });
                } else {
                    this.props.addToast('Unable to add user in Auth0.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handlePasswordReset = (auth0) => {
        this.props.log('AdminContainer.js/handlePasswordReset (auth0)', auth0);
        fetch('/api/auth/reset', {
            method: 'POST',
            body: JSON.stringify({
                auth0: 'auth0|' + auth0,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Password reset email sent.', 5, 'success')
                } else {
                    this.props.addToast('Unable to send password reset email.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditUser = () => {
        this.props.log('AdminContainer.js/handleEditUser');
        fetch('/api/users/' + this.state.editUser.auth0, {
            method: 'PUT',
            body: JSON.stringify({
                firstName: this.state.editUser.firstName,
                lastName: this.state.editUser.lastName,
                emailAddress: this.state.editUser.emailAddress,
                employeeId: this.state.editUser.employeeId,
                active: this.state.editUser.active,
                roles: this.state.editUser.roles,
                clients: this.state.editUser.clients
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let users = [...this.state.users];
                    const index = users.findIndex(item => item.auth0 === this.state.editUser.auth0);
                    users[index] = {
                        'firstName': this.state.editUser.firstName,
                        'lastName': this.state.editUser.lastName,
                        'emailAddress': this.state.editUser.emailAddress,
                        'employeeId': this.state.editUser.employeeId,
                        'active': this.state.editUser.active,
                        'auth0': this.state.editUser.auth0,
                        'roles': this.state.editUser.roles,
                        'clients': this.state.editUser.clients
                    };
                    this.props.addToast('User updated successfully.', 5, 'success')
                    this.setState({
                        users: users,
                        editUser: { ...this.blankUser }
                    }, () => this.props.refreshUser());
                } else {
                    this.props.addToast('Unable to update user.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeRole = (e, type) => {
        this.props.log('AdminContainer.js/onChangeRole (e, type)', e, type);
        e.persist();
        let thisRole = (type === 'edit') ? this.state.editRole : this.state.newRole;
        switch (e.target.name) {
            case "active":
                thisRole[e.target.name] = !thisRole[e.target.name];
                break;
            case "permissions":
                const id = parseInt(String(e.target.id).split('_')[1]);
                const index = thisRole.permissions.findIndex(item => item === id);
                if (index > -1) thisRole.permissions.splice(index, 1);
                if (e.target.checked) thisRole.permissions.push(id);
                break;
            case "users":
                const userId = String(e.target.id).split('_')[1];
                const roleId = parseInt(String(e.target.id).split('_')[2]);
                const userIndex = this.state.users.findIndex(item => item.auth0 === userId);
                const roleIndex = this.state.users[userIndex].roles.findIndex(item => item === roleId);
                if (roleIndex > -1) this.state.users[userIndex].roles.splice(roleIndex, 1);
                if (e.target.checked) this.state.users[userIndex].roles.push(roleId);
                break;
            default:
                thisRole[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editRole: thisRole } : { newRole: thisRole };
        });
    }

    onEditRole = (id) => {
        this.props.log('AdminContainer.js/onEditRole (id)', id);
        const role = [...this.state.roles].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editRole: {
                    'id': id,
                    'role': role.role,
                    'description': role.description,
                    'active': role.active,
                    'order': role.order,
                    'permissions': role.permissions,
                    'users': [...this.state.users].filter(user => user.roles.findIndex(i => i === id) > -1).map(user => user.auth0)
                }
            }
        })
    }

    onDeleteRole = (id) => {
        this.props.log('AdminContainer.js/onDeleteRole (id)', id);
        fetch('/api/roles/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let roles = [...this.state.roles];
                    roles.splice(roles.findIndex(item => item.id === id), 1);
                    this.setState({
                        roles: roles,
                        editRole: { ...this.blankRole },
                    });
                    this.props.addToast('Role deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete role.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelRole = () => {
        this.props.log('AdminContainer.js/handleCancelRole');
        this.setState({
            editRole: { ...this.blankRole },
        })
    }

    handleEditRole = () => {
        this.props.log('AdminContainer.js/handleEditRole');
        fetch('/api/roles/' + this.state.editRole.id, {
            method: 'PUT',
            body: JSON.stringify({
                role: this.state.editRole.role,
                description: this.state.editRole.description,
                active: this.state.editRole.active,
                order: this.state.editRole.order,
                users: [...this.state.users].filter(user => user.roles.findIndex(role => role === this.state.editRole.id) > -1).map(user => user.auth0),
                permissions: this.state.editRole.permissions
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let roles = [...this.state.roles];
                    const index = roles.findIndex(item => item.id === this.state.editRole.id);
                    roles[index] = {
                        'role': this.state.editRole.role,
                        'description': this.state.editRole.description,
                        'active': this.state.editRole.active,
                        'order': this.state.editRole.order,
                        'id': this.state.editRole.id,
                        'permissions': this.state.editRole.permissions
                    };
                    this.props.addToast('Role updated successfully.', 5, 'success')
                    this.setState({
                        roles: roles,
                        editRole: { ...this.blankRole }
                    }, () => this.props.refreshUser());
                } else {
                    this.props.addToast('Unable to update role.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddRole = (e) => {
        this.props.log('AdminContainer.js/handleAddRole (name, value, e)', e.target.name, e.target.value, e);
        let newOrder = Math.max(...this.state.roles.map(i => i['Order']), 0) + 10;
        fetch('/api/roles/', {
            method: 'POST',
            body: JSON.stringify({
                role: this.state.newRole.role,
                description: this.state.newRole.description,
                active: this.state.newRole.active,
                order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    let roles = [...this.state.roles];
                    roles.push({
                        'id': results.data,
                        'role': this.state.newRole.role,
                        'description': this.state.newRole.description,
                        'active': this.state.newRole.active,
                        'order': newOrder,
                        'Permissions': [{}],
                        'permissions': []
                    });
                    this.setState({
                        roles: roles,
                        newRole: { ...this.blankRole }
                    }, () => {
                        this.props.addToast('Role added successfully.', 5, 'success')
                    });
                } else {
                    this.props.addToast('Unable to add role.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangePermission = (e, type) => {
        this.props.log('AdminContainer.js/onChangePermission (e,type)', e, type);
        e.persist();
        let thisPermission = (type === 'edit') ? this.state.editPermission : this.state.newPermission;
        switch (e.target.name) {
            case "active":
                thisPermission[e.target.name] = !thisPermission[e.target.name];
                break;
            case "roles":
                const roleId = parseInt(String(e.target.id).split('_')[1]);
                const permissionId = parseInt(String(e.target.id).split('_')[2]);
                const roleIndex = this.state.roles.findIndex(item => item.id === roleId);
                const permissionIndex = this.state.roles[roleIndex].permissions.findIndex(item => item === permissionId);
                if (permissionIndex > -1) this.state.roles[roleIndex].permissions.splice(permissionIndex, 1);
                if (e.target.checked) this.state.roles[roleIndex].permissions.push(permissionId);
                break;
            default:
                thisPermission[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editPermission: thisPermission } : { newPermission: thisPermission };
        });
    }

    onEditPermission = (id) => {
        this.props.log('AdminContainer.js/onEditPermission (id)', id);
        const permission = [...this.state.permissions].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editPermission: {
                    'id': id,
                    'permission': permission.permission,
                    'description': permission.description,
                    'api': permission.api,
                    'method': permission.method,
                    'active': permission.active,
                    'order': permission.order
                }
            }
        })
    }

    onDeletePermission = (id) => {
        this.props.log('AdminContainer.js/onDeletePermission (id)', id);
        fetch('/api/permissions/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let permissions = [...this.state.permissions];
                    permissions.splice(permissions.findIndex(item => item.id === id), 1);
                    this.props.addToast('Permissions deleted successfully.', 5, 'success')
                    this.setState({
                        permissions: permissions,
                        editPermission: { ...this.blankPermission },
                    });
                } else {
                    this.props.addToast('Unable to delete permission.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelPermission = () => {
        this.props.log('AdminContainer.js/handleCancelPermission');
        this.setState({
            editPermission: { ...this.blankPermission },
        })
    }

    handleEditPermission = () => {
        this.props.log('AdminContainer.js/handleEditPermission');
        fetch('/api/permissions/' + this.state.editPermission.id, {
            method: 'PUT',
            body: JSON.stringify({
                permission: this.state.editPermission.permission,
                description: this.state.editPermission.description,
                api: this.state.editPermission.api,
                method: this.state.editPermission.method,
                active: this.state.editPermission.active,
                order: this.state.editPermission.order,
                roles: [...this.state.roles].filter(role => role.permissions.findIndex(permission => permission === this.state.editPermission.id) > -1).map(role => role.id)
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let permissions = [...this.state.permissions];
                    const index = permissions.findIndex(item => item.id === this.state.editPermission.id);
                    permissions[index] = {
                        'permission': this.state.editPermission.permission,
                        'description': this.state.editPermission.description,
                        'api': this.state.editPermission.api,
                        'method': this.state.editPermission.method,
                        'active': this.state.editPermission.active,
                        'order': this.state.editPermission.order,
                        'id': this.state.editPermission.id
                    };
                    this.props.addToast('Permission updated successfully.', 5, 'success')
                    this.setState({
                        permissions: permissions,
                        editPermission: { ...this.blankPermission }
                    }, () => this.props.refreshUser());
                } else {
                    this.props.addToast('Unable to update permission.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddPermission = (e) => {
        this.props.log('AdminContainer.js/handleAddPermission');
        let newOrder = Math.max(...this.state.permissions.map(i => i['Order']), 0) + 10;
        fetch('/api/permissions/', {
            method: 'POST',
            body: JSON.stringify({
                permission: this.state.newPermission.permission,
                description: this.state.newPermission.description,
                api: this.state.newPermission.api,
                method: this.state.newPermission.method,
                active: this.state.newPermission.active,
                order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    let permissions = [...this.state.permissions];
                    permissions.push({
                        'id': results.data,
                        'permission': this.state.newPermission.permission,
                        'description': this.state.newPermission.description,
                        'api': this.state.newPermission.api,
                        'method': this.state.newPermission.method,
                        'active': this.state.newPermission.active,
                        'order': newOrder
                    });
                    this.props.addToast('Permission added successfully.', 5, 'success')
                    this.setState({
                        permissions: permissions,
                        newPermission: { ...this.blankPermission }
                    });
                } else {
                    this.props.addToast('Unable to add permission.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeClient = (e, type) => {
        this.props.log('AdminContainer.js/onChangeClient (e,type)', e.target.name, e.target.value, e.target.checked, e.target.id, type);
        e.persist();
        let thisClient = (type === 'edit') ? this.state.editClient : this.state.newClient;
        switch (e.target.name) {
            case "active":
                thisClient[e.target.name] = !thisClient[e.target.name];
                break;
            case "users":
                const auth0 = String(e.target.id).split('_')[1];
                const clientId = parseInt(String(e.target.id).split('_')[2]);
                const userIndex = thisClient.users.findIndex(item => item === auth0);
                const userIndex2 = [...this.state.users].findIndex(item => item.auth0 === auth0);
                const clientIndex2 = [...this.state.users][userIndex2].clients.findIndex(item => item === clientId);
                if (userIndex > -1) thisClient.users.splice(userIndex, 1);
                if (e.target.checked) thisClient.users.push(auth0);
                if (clientIndex2 > -1) this.state.users[userIndex2].clients.splice(clientIndex2, 1);
                if (e.target.checked) this.state.users[userIndex2].clients.push(clientId);
                break;
            default:
                thisClient[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editClient: thisClient } : { newClient: thisClient };
        });
    }

    onEditClient = (id) => {
        this.props.log('AdminContainer.js/onEditClient (id)', id);
        const client = [...this.props.clients].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editClient: {
                    'id': id,
                    'client': client.client,
                    'uuid': client.uuid,
                    'customerNumber': client.customerNumber != null ? client.customerNumber : '',
                    'active': client.active,
                    'users': client.users
                }
            }
        })
    }

    onDeleteClient = (id) => {
        this.props.log('AdminContainer.js/onDeleteClient (id)', id);
        fetch('/api/clients/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Client deleted successfully.', 5, 'success')
                    let clients = [...this.props.clients];
                    clients.splice(clients.findIndex(item => item.id === id), 1);
                    this.setState({
                        clients: clients,
                        editClient: { ...this.blankClient },
                    }, () => this.props.getClients());
                } else {
                    this.props.addToast('Unable to delete client.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelClient = () => {
        this.props.log('AdminContainer.js/handleCancelClient');
        this.setState({
            editClient: { ...this.blankClient },
        })
    }

    handleEditClient = () => { // TODO
        this.props.log('AdminContainer.js/handleEditClient');
        fetch('/api/clients/' + this.state.editClient.id, {
            method: 'PUT',
            body: JSON.stringify({
                client: this.state.editClient.client,
                uuid: this.state.editClient.uuid,
                customerNumber: this.state.editClient.customerNumber != null ? this.state.editClient.customerNumber : '',
                active: this.state.editClient.active,
                users: this.state.editClient.users
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    // let clients = [...this.state.clients];
                    this.setState({
                        editClient: { ...this.blankClient }
                    }, () => this.props.getClients());
                    this.props.addToast('Client updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update client.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddClient = (e) => {
        this.props.log('AdminContainer.js/handleAddClient');
        // let newOrder = Math.max(...this.state.clients.map(i => i['Order']), 0) + 10;
        fetch('/api/clients/', {
            method: 'POST',
            body: JSON.stringify({
                client: this.state.newClient.client,
                uuid: this.state.newClient.uuid,
                customerNumber: this.state.newClient.customerNumber != null ? this.state.newClient.customerNumber : '',
                active: this.state.newClient.active,
                // order: newOrder
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    let clients = [...this.props.clients];
                    clients.push({
                        'id': results.data,
                        'client': this.state.newClient.client,
                        'uuid': this.state.newClient.uuid,
                        'customerNumber': this.state.newClient.customerNumber != null ? this.state.newClient.customerNumber : '',
                        'active': this.state.newClient.active,
                        'users': []
                    });
                    this.props.addToast('Client added successfully.', 5, 'success')
                    this.setState({
                        clients: clients,
                        newClient: { ...this.blankClient }
                    }, () => this.props.getClients());
                } else {
                    this.props.addToast('Unable to add client.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render() {
        this.props.info('AdminContainer.js/render');
        return (
            (this.state.isLoaded === 3) ?
                <>
                    {this.props.showUsers ?
                        <CollapseCard title="Users" open={true}>
                            <AdminUsers
                                userPermissions={this.props.userPermissions}
                                users={this.state.users}
                                roles={this.state.roles}
                                clients={this.props.clients}
                                newUser={this.state.newUser}
                                editUser={this.state.editUser}
                                onSelectAll={this.onSelectAll}
                                onChange={this.onChangeUser}
                                onEdit={this.onEditUser}
                                handlePasswordReset={this.handlePasswordReset}
                                handleAdd={this.handleAddUser}
                                handleEdit={this.handleEditUser}
                                handleCancel={this.handleCancelUser}
                                log={this.props.log}
                                info={this.props.info}
                                isFieldNull={this.props.isFieldNull}
                                employees={this.state.employees}
                            />
                        </CollapseCard> : <></>}
                    {this.props.showRoles ?
                        <CollapseCard title="Roles" open={true}>
                            <AdminRoles
                                users={this.state.users}
                                roles={this.state.roles}
                                permissions={this.state.permissions}
                                newRole={this.state.newRole}
                                editRole={this.state.editRole}
                                editUser={this.state.editUser}
                                onSelectAll={this.onSelectAll}
                                onChange={this.onChangeRole}
                                onEdit={this.onEditRole}
                                onDelete={this.onDeleteRole}
                                handleAdd={this.handleAddRole}
                                handleEdit={this.handleEditRole}
                                handleCancel={this.handleCancelRole}
                                log={this.props.log}
                                info={this.props.info}
                                isFieldNull={this.props.isFieldNull}
                            />
                        </CollapseCard> : <></>}
                    {this.props.showPermissions ?
                        <CollapseCard title="Permissions" open={true}>
                            <AdminPermissions
                                userPermissions={this.props.userPermissions}
                                roles={this.state.roles}
                                permissions={this.state.permissions}
                                newPermission={this.state.newPermission}
                                editPermission={this.state.editPermission}
                                onSelectAll={this.onSelectAll}
                                onChange={this.onChangePermission}
                                onEdit={this.onEditPermission}
                                onDelete={this.onDeletePermission}
                                handleAdd={this.handleAddPermission}
                                handleEdit={this.handleEditPermission}
                                handleCancel={this.handleCancelPermission}
                                log={this.props.log}
                                info={this.props.info}
                                isFieldNull={this.props.isFieldNull}
                            />
                        </CollapseCard> : <></>}
                    {this.props.showClients ?
                        <CollapseCard title="Companies" open={true}>
                            <AdminClients
                                userPermissions={this.props.userPermissions}
                                clients={this.props.clients}
                                users={this.state.users}
                                newClient={this.state.newClient}
                                editClient={this.state.editClient}
                                onSelectAll={this.onSelectAll}
                                onChange={this.onChangeClient}
                                onEdit={this.onEditClient}
                                onDelete={this.onDeleteClient}
                                handleAdd={this.handleAddClient}
                                handleEdit={this.handleEditClient}
                                handleCancel={this.handleCancelClient}
                                log={this.props.log}
                                info={this.props.info}
                                isFieldNull={this.props.isFieldNull}
                            />
                        </CollapseCard> : <></>}
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default AdminContainer;
